(ns ncr.fragment.access
  (:require
   [cljs.core.async :as async :refer-macros [go]]
   [clojure.core.match :refer [match]]
   [lambdaisland.glogi :as log]
   [uix.core.alpha :as uix]
   [ncr.me :as me]
   [ncr.etc.util :as u]
   [ncr.widgets.pf :as wpf]
   [ncr.widgets.core :as w]
   [ncr.etc.pf :as pf :refer [l-flex l-flex-item]]
   [ncr.widgets.domain :as wdom]
   [ncr.etc.pubsub :as ps]
   [ncr.etc.rhf :as rhf]
   [ncr.etc.modal :as m]
   [ncr.etc.alert :as a]
   [ncr.backend :as b]))

(defn- c-promote-dialog [{:keys [defaults title is-disabled] :as props}]
  (let
    [ref (uix/ref)
     {:keys [submit] :as form}
     (rhf/use-form
       {:should-focus-error false
        :default-values defaults})

     managers
     (->> (uix/context me/*context*)
       (:cluster)
       (:users)
       (filter #(and (:active %) (:isManager %)))
       (sort-by :name))

     modal-id :new-fragment-modal]

    (m/use-submit-form modal-id ref submit)

    [m/c-modal
     {:title title
      :variant :medium
      :id modal-id
      :ref ref
      :is-overflow-visible true
      :actions
      [[pf/c-button
        {:variant :primary
         :is-disabled is-disabled
         :on-click submit}
        "Ok"]
       [pf/c-button
        {:variant :link :on-click #(m/close! nil)} "Cancel"]]}

     [pf/c-form {:on-submit submit}
      (let [specials [wdom/spec-everyone]]
        [:<>
         (let [id (uix/memo #(gensym) [])]
           [pf/c-form-group {:label "Read Access" :field-id id}
            [wdom/c-users-selector
             (merge props
               {:id id
                :name :read-acl
                :form form
                :specials specials
                :on-empty-enter (rhf/modal-submit form assoc :mode :set)})]])

         (let [id (uix/memo #(gensym) [])]
           [pf/c-form-group {:label "Write Access" :field-id id}
            [wdom/c-users-selector
             (merge props
               {:id id
                :name :write-acl
                :form form
                :specials specials
                :on-empty-enter (rhf/modal-submit form assoc :mode :set)})]])

         [pf/c-form-group {:label "Managers"}
          [pf/c-chip-group {:num-chips 5}
           (for [{:keys [id name]} managers]
             ^{:key id} [pf/c-chip {:is-read-only true} name])]]

         (let [id (uix/memo #(gensym) [])]
           [pf/c-form-group {:label "Owner" :field-id id}
            [wdom/c-user-selector
             (merge props
               {:id id
                :name :owner
                :form form
                :on-empty-enter (rhf/modal-submit form assoc :mode :set)})]])])]]))

(defn !quick-promote [me fragments]
  (go
    (when
      (<!
        (a/!fragment-operation
          {:operation-title "Moving to Accepted"
           :success-title "Moved to Accepted"
           :fragments fragments}

          (b/!multi-mutation
            (map
              (fn [{:keys [id]}]
                [(keyword id) [:reference_quick_promote {:id id}]])
              fragments))))
      (ps/pub! [:me/load]))))

(defn !promote [me fragments]
  (go
    (let [defaults {:owner (get me :id)}]
      (if-let [{:keys [read-acl write-acl owner]} (<! (m/!modal #'c-promote-dialog {:title "Move to Accepted" :defaults defaults}))]
        (when
          (<!
            (a/!fragment-operation
              {:operation-title "Moving to Accepted"
               :success-title "Moved to Accepted"
               :fragments fragments}

              (b/!multi-mutation
                (map
                  (fn [{:keys [id]}]
                    [(keyword id)
                     [:reference_promote
                      {:id id :readACL (into [] read-acl) :writeACL (into [] write-acl) :owner owner}]])
                  fragments))))
          (ps/pub! [:me/load]))
        [:error :cancel]))))

(defn !permissions [_me fragments]
  (go
    (let
      [props
       {:defaults
        {:owner (u/distinct-singleton (map :owner fragments))
         :read-acl
         (or
           (u/distinct-singleton
             (map (comp set :readACL) fragments)) #{})
         :write-acl
         (or
           (u/distinct-singleton
             (map (comp set :writeACL) fragments)) #{})}
        :title "Permissions"
        :is-disabled
        (not
          (apply u/and* (map :ownerWritableHint fragments)))}]

      (if-let [{:keys [read-acl write-acl owner]} (<! (m/!modal #'c-promote-dialog props))]
        (<!
          (a/!fragment-operation
            {:operation-title "Updating Permissions"
             :success-title "Permissions Updated"
             :fragments fragments}
            (b/!multi-mutation
              (map
                (fn [{:keys [id]}]
                  [(keyword id)
                   [:reference_update_access
                    {:id id :readACL (into [] read-acl) :writeACL (into [] write-acl) :owner owner}]])
                fragments))))
        [:error :cancel]))))


(defn- c-avatar [{:keys [picture name]} role]
  [pf/c-tooltip {:content [:span (u/format "%s (%s)" name role)] :position :auto :enable-flip true}
   [w/c-avatar
    {:class :pf-m-small
     :alt
     (u/initials name)
     :src
     picture
     :border :light}]])

(defn- c-owner-separator []
  [l-flex-item
   {:align-self :align-self-center
    :class :ncr-u-border-left
    :style
    {:width "1px"
     :height "2em"}}])

(defn c-access-line [{:keys [me]} {:keys [promotedHint readACL writeACL] :as entry}]
  (if promotedHint
    [l-flex {:space-items :space-items-sm :align-items :align-items-flex-start}
     (let
       [not-owner? (complement #{(get entry :owner)})]
       (when (or (seq readACL) (seq writeACL))
         (letfn
           [(wrap [tag items]
              (->> items
                (filter not-owner?)
                (map
                  (fn [id]
                    (if (= "$everyone" id)
                      [tag
                       {:id "$everyone"
                        :name "All"
                        :isManager false
                        :active true
                        :picture :account-multiple}]
                      (when-let [{:keys [isManager] :as user} (me/user-by-id me id)]
                        (when-not isManager
                          [tag user])))))
                (filter some?)))]
           (let
             [all
              (concat
                (wrap :read
                  (let [not-writer? (complement (set writeACL))]
                    (filter not-writer? readACL)))
                (wrap :write writeACL))]

             (when (seq all)
               [:<>
                [l-flex {:space-items :space-items-xs :align-items :align-items-flex-start}
                 (into [:<>]
                   (->> all
                     (sort-by (comp :name second))
                     (map
                       (fn [[tag account]]
                         [l-flex-item
                          [c-avatar account
                           (case tag
                             :read "Read"
                             :write "Read/Write")]]))))]
                [c-owner-separator]])))))
     [l-flex-item
      [c-avatar (me/user-by-id me (get entry :owner)) "Owner"]]]

    [l-flex {:space-items :space-items-sm :align-items :align-items-flex-start}
     (let [{:keys [isShared access]} (me/folder-by-id me (get entry :folder))]
       (when (and isShared (seq access))
         (let
           [access
            (->> access
              (filter (complement #{(get entry :creator)}))
              (map (partial me/user-by-id me))
              (sort-by :name))]

           (when (seq access)
             [:<>
              [l-flex {:space-items :space-items-xs :align-items :align-items-flex-start}
               (into [:<>]
                 (map
                   (fn [account]
                     [l-flex-item
                      [c-avatar account "Shared Folder"]])
                   access))]
              [c-owner-separator]]))))

     [l-flex-item
      [c-avatar (me/user-by-id me (get entry :creator)) "Creator"]]]))
